module.exports = __webpack_public_path__ + "static/media/Rubik-Light.7dea6ef7.otf";